import React from 'react';

const Alert = ({ type = 'info', message, onClose, className = '' }) => {
  const alertClass = `alert alert-${type} ${className}`;
  
  return (
    <div className={alertClass} role="alert">
      {message}
      {onClose && (
        <button 
          type="button" 
          className="btn-close" 
          onClick={onClose}
          aria-label="Close"
        ></button>
      )}
    </div>
  );
};

export default Alert;




